import React from "react";
import StyledDataGrid from "styles/styledDataGrid";
import { Toolbar, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Box } from "@mui/material";

const CommonDialogDataGrid = ({
  rows,
  columns,
  checkboxSelection = false,
  selectionModel = [],
  onSelectionChange = () => {},
  getRowId,
}) => {
  const CustomToolbar = () => (
    <Toolbar
      sx={{
        justifyContent: "space-between",
        px: 1,
        py: 0,
        alignItems: "center",
      }}
    >
      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput.split(",").map((value) => value.trim())
        }
      />
    </Toolbar>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "100%", // Important: fill available height
        minHeight: 0, // Important for flex children to shrink correctly
      }}
    >
      <StyledDataGrid
        rows={rows}
        columns={columns}
        checkboxSelection={checkboxSelection}
        disableRowSelectionOnClick
        rowHeight={40}
        headerHeight={40}
        rowSelectionModel={selectionModel}
        onRowSelectionModelChange={onSelectionChange}
        getRowId={getRowId}
        sx={{ flex: 1 }}
        slots={{
          toolbar: () => <CustomToolbar />,
        }}
      />
    </Box>
  );
};

export default CommonDialogDataGrid;
